import BREAKPOINTS from '@lib/constants/breakpoints';
import Section from 'components/atoms/Section';
import PageContainer from 'components/molecules/PageContainer';
import SignInForm from 'components/organisms/forms/SignInForm';
import { NextPage } from 'next';
import styled from 'styled-components';

const AuthWrapper = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 600px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    position: unset;
    transform: none;
    padding-top: 64px;
    max-width: none;
  }

  h1 {
    font-size: 32px;
  }
`;

const SectionWrapper = styled(Section)`
  min-height: 100vh;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    padding: 16px;
  }
`;

const SignIn: NextPage = () => (
    <PageContainer
      title="Entrar - Luna"
      metaDescription="Acesse o sistema da Luna para verificar seu seguro"
      showFooter={false}
    >
      <SectionWrapper hasBorder={false}>
        <AuthWrapper>
          <SignInForm  />
        </AuthWrapper>
      </SectionWrapper>
    </PageContainer>
  );

export default SignIn;
